import { ChoicesOrderItemType } from '@/sections/administrative/accounts/orders/context';

export interface IMilestoneItem {
  _id: string;
  orderItem: IMilestoneOrderItem;
  paymentDate: Date;
  milestonePeriod: number;
  type: string;
  amount?: number;
  totalDiscount: number;
  subtotal: number;
  total: number;
  startPeriod: Date;
  endPeriod: Date;
  createdAt: Date;
  updatedAt: Date;
  subscription: string;
  orderNumber: string;
  product: IMilestoneProduct;
  plan: IMilestonePlan;
  status: ChoicesStatusMilestone;
  description?: string;
  billingOrders?: IMilestoneBillingOrder[];
}

export interface IMilestoneOrderItem {
  _id: string;
  order: IMilestoneOrder;
  quantity: number;
  orderItemType: ChoicesOrderItemType;
  oldSubscription: IMilestoneOldSubscription;
  product: IMilestoneProduct;
  plan: IMilestonePlan;
}

export interface IMilestoneOldSubscription {
  purchaseQuantity: number;
}

export interface IMilestoneOrder {
  _id: string;
  organization: string;
  number: number;
  OVNumber: string;
}

export type SubscriptionMilestoneTableFilters = {
  search: string;
  page: number;
  pageSize: number;
  status: { _id: ChoicesStatusMilestone; label: string }[];
};

export interface IMilestoneProduct {
  _id: string;
  name: string;
}

export interface IMilestonePlan {
  _id: string;
  name: string;
  code: string;
}

export enum ChoicesStatusMilestone {
  SCHEDULED = 'scheduled',
  OPEN_TO_BILL = 'open_to_bill',
  PAST_DUE = 'past_due',
  IN_PROGRESS = 'in_progress',
  BILLED = 'billed',
  CANCELLED = 'cancelled',
  REVERSED = 'reversed',
}

export interface IMilestoneBillingOrder {
  _id: string;
  number: number;
}
